/* import __COLOCATED_TEMPLATE__ from './single-page.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();